import BaseService from "./BaseService";

export default {
  index() {
    return BaseService.get("/projects");
  },
  addUserToProject(data) {
    return BaseService.post("/projects/addUser", data);
  },
  deleteUserFromProject(membershipId) {
    return BaseService.delete(
      `/projects/userProjectRelationships/${membershipId}`
    );
  },
  createCompanyProject(data) {
    return BaseService.post("/companies", data);
  },
  createFamilyProject(data) {
    return BaseService.post("/families", data);
  },
  updateCompanyProject(id, data) {
    return BaseService.put("/companies/" + id, data);
  },
  updateFamilyProject(id, data) {
    return BaseService.put("/families/" + id, data);
  },
  deleteCompanyProject(id) {
    return BaseService.delete("/companies/" + id);
  },
  deleteFamilyProject(id) {
    return BaseService.delete("/families/" + id);
  },
};
